var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1AED9E"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.617 5.143a4.08 4.08 0 0 0-4.046 4.114v5.486c0 2.272 1.809 4.114 4.046 4.114h4.766c2.237 0 4.046-1.842 4.046-4.114V9.257c0-2.271-1.809-4.114-4.046-4.114zm-.026 1.714c-1.272 0-2.305 1.102-2.305 2.465v5.357c0 1.363 1.033 2.464 2.305 2.464h4.818c1.272 0 2.305-1.101 2.305-2.464V9.322c0-1.363-1.033-2.465-2.305-2.465z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.857 10.509c0-.6.484-1.08 1.08-1.08h.412c.6 0 1.08.484 1.08 1.08v.411c0 .6-.485 1.08-1.08 1.08h-.412a1.08 1.08 0 0 1-1.08-1.08zm0 3.857c0-.6.484-1.08 1.08-1.08h.412c.6 0 1.08.484 1.08 1.08v.411c0 .6-.485 1.08-1.08 1.08h-.412a1.08 1.08 0 0 1-1.08-1.08z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgId);
export default __webpack_public_path__ + "static/media/id.174ff001135cda246da6777a755ced54.svg";
export { ForwardRef as ReactComponent };